import { createContext, useContext } from "react";
import { CadApiConfig, PutCadApiConfig } from "../types/cad-api-config";

export interface ICadApiContext {
    getConfig: () => Promise<CadApiConfig>;
    updateConfig: (config: PutCadApiConfig) => Promise<void>;
    apiUrl: string;
    getGeoJsonLayers: () => Promise<string[]>;
    shutdownApi: () => Promise<void>;
}

export const CadApiContext = createContext<ICadApiContext>(null);

export const useCadApiContext = () => useContext(CadApiContext);
